module.exports = __webpack_public_path__ + "static/media/Location_Icon.3ae943b5.svg";